// extracted by mini-css-extract-plugin
export var quillEditor = "_jo-1";
export var variable = "_jo-0";